import { render, staticRenderFns } from "./DocumentUploadDialog.vue?vue&type=template&id=d708f1da&lang=pug&"
import script from "./DocumentUploadDialog.vue?vue&type=script&lang=ts&"
export * from "./DocumentUploadDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports